import * as RadixSwitch from "@radix-ui/react-switch";
import { cn } from "../utils";

/** Props Interface */
interface SwitchProps {
	id?: string;
	isDisabled?: boolean;
	checked: boolean;
	onCheckedChange: (checked: boolean) => void;
	"data-cy"?: string;
}

export function Switch({ id, isDisabled, checked, onCheckedChange, "data-cy": cyId }: SwitchProps) {
	return (
		<div className="relative">
			<RadixSwitch.Root
				id={id}
				className={cn(
					"cursor-pointer",
					"bg-primaryGray-300 dark:bg-primaryGray-600 p-px rounded-full w-8 h-4.5",
					"data-[state=checked]:bg-linear-to-r",
					"data-[state=checked]:from-accent-500 data-[state=checked]:to-accent-800",
					"flex flex-row",
					isDisabled && "opacity-50 cursor-not-allowed",
					"active:[&_.switch-thumb]:aspect-[1.15/1]!",
				)}
				disabled={isDisabled}
				checked={checked}
				onCheckedChange={onCheckedChange}
				data-cy={cyId}
			>
				<RadixSwitch.Thumb
					className={cn(
						"switch-thumb",
						"block shadow data-[state=checked]:ml-[100%] rounded-full h-full aspect-square transition-all data-[state=checked]:-translate-x-full",
						"bg-white border border-primary-500/10",
					)}
				/>
			</RadixSwitch.Root>
		</div>
	);
}
